module.exports = __webpack_public_path__ + "media/images/parrot-95aa0f4905572f403ebc9b4e4b2f2818.jpeg";